/**
 * @package DMV FAQ
 * @version 1.0.0
 */

$(document).ready(function () {
  var qs = (function (a) {
    if (!a[0]) {
      return false;
    }

    var b = {}, p, i;

    for (i = 0; i < a.length; ++i) {
      p = a[i].split('=', 2);
      if (p.length === 1) {
        b[p[0]] = '';
      } else {
        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
      }
    }

    return b;
  })(window.location.search.substr(1).split('&'));

  if (qs && typeof qs.hl !== 'undefined') {
    var s = '(' + qs.hl + ')',
      regex = new RegExp(s, 'gi');
    $('.faq-list > dd').each(function () {
      if ($(this).text().toLowerCase().indexOf(qs.hl.toLowerCase()) !== -1) {
        $(this).html(function (index, html) {
          return html.replace(regex, '<span class="hilite">$1</span>');
        }).addClass('show').prev().removeClass('collapsed').prop('aria-expanded', true);
      }
    });

    var $first_match = $('span.hilite').first();
    if ($first_match.length) {
      $(document).scrollTop($first_match.parents('dd').prev('dt').offset().top);
    }
  }

  /**
   * Scroll to a given question when it's in the url.
   */
  const hash = window.location.hash;
  const questionAnswer = hash ? document.querySelector(hash) : null;
  if (hash && questionAnswer) {

    new Promise((resolve) => {
      setTimeout(() => {
        questionAnswer.classList.remove('collapse');
        questionAnswer.classList.add('show');
        resolve();
      }, 500);
    }).then(() => {
      $('html, body').animate({
        scrollTop: $(questionAnswer).offset().top - 90,
      }, 1000);
    });

  }
});



// WEBPACK FOOTER //
// ./scripts/plugins/dmv-faq/index.js